import type { InstitutionTheme } from '../types';
import { evcColors } from './colors';

// Evergreen Valley College institutional theme (W54 Worker E, S3).
//
// Brand strings from the catalog: the college writes "EVC" throughout; "Student Self Service"
// (sso.sjeccd.edu) is the San José–Evergreen CCD registration portal named on the academic
// calendar page. Colors per ./colors.ts (a measured green primary + a neutral accent; driver
// ruling option (c) until the owner supplies the brand guide).
//
// Example course codes are the three code SHAPES the S0 probe walk found
// (onboarding/evc/probes/course_index_s0.json): MATH 021 (zero-padded local), ENGL C1000
// (Common Course Number, printed in the C form), ACCTG 001A (padded + letter suffix). First
// entry is the primary example.
export const evcTheme: InstitutionTheme = {
  slug: 'evc',
  universityName: 'Evergreen Valley College',
  universityShortName: 'EVC',
  registrationPortalName: 'Student Self Service',
  exampleCourseCodes: ['MATH 021', 'ENGL C1000', 'ACCTG 001A'],
  colors: evcColors,
};
